import { Injectable } from "@angular/core";
import { Advertiser } from "app/modules/admin/advertisers/interfaces/advertiser.interface";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SelectedAdvertiserService {
    private readonly STORAGE_KEY = "selected_advertiser";
    private selectedAdvertiserSubject = new BehaviorSubject<Advertiser | null>(null);
    public selectedAdvertiser$ = this.selectedAdvertiserSubject.asObservable();

    constructor() {
        this.loadFromStorage();
    }

    setSelectedAdvertiser(advertiser: Advertiser | null): void {
        this.selectedAdvertiserSubject.next(advertiser);
        this.saveToStorage(advertiser);
    }

    getSelectedAdvertiser(): Advertiser | null {
        return this.selectedAdvertiserSubject.value;
    }

    getSelectedAdvertiserId(): string | null {
        const advertiser = this.selectedAdvertiserSubject.value;
        return advertiser?.id || null;
    }

    clearSelectedAdvertiser(): void {
        this.selectedAdvertiserSubject.next(null);
        this.removeFromStorage();
    }

    private saveToStorage(advertiser: Advertiser | null): void {
        if (advertiser) {
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(advertiser));
        } else {
            this.removeFromStorage();
        }
    }

    private loadFromStorage(): void {
        try {
            const stored = localStorage.getItem(this.STORAGE_KEY);
            if (stored && stored.trim()) {
                const advertiser = JSON.parse(stored) as Advertiser;
                if (advertiser && advertiser.id) {
                    this.selectedAdvertiserSubject.next(advertiser);
                } else {
                    this.removeFromStorage();
                }
            }
        } catch (error) {
            console.error("Error loading advertiser from localStorage:", error);
            this.removeFromStorage();
        }
    }

    private removeFromStorage(): void {
        localStorage.removeItem(this.STORAGE_KEY);
    }
}
